import { render, staticRenderFns } from "./no-footer.vue?vue&type=template&id=e0516024"
import script from "./no-footer.vue?vue&type=script&lang=ts"
export * from "./no-footer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Header: require('/usr/src/app/components/Header.vue').default})
